const state = {
    items: [],
}
export default state;
